import LoadingCard from "../LoadingCard";

const DeviceTable = ({
  devices,
  onDeepAnalyse,
  loading,
  ingestingDevice,
  ingestionCompletedDevice,
}) => {
  if (loading) {
    return (
      <div className="py-8">
        <LoadingCard
          message="Loading devices and drugs…"
          subMessage="Fetching the latest studies."
        />
      </div>
    );
  }

  if (ingestingDevice) {
    return (
      <div className="py-8">
        <LoadingCard
          message={`Running ingestion for ${ingestingDevice}…`}
          subMessage="This may take a few minutes. Please keep this tab open."
          progress={ingestionCompletedDevice === ingestingDevice ? 100 : undefined}
        />
      </div>
    );
  }

  if (!devices?.length) {
    return (
      <div className="rounded-xl border border-base-300 bg-base-100 p-8 text-center text-base-content/70">
        No devices or drugs found. Create a study in Clinical Literature Evaluation first.
      </div>
    );
  }

  return (
    <div className="max-h-[calc(100vh-320px)] overflow-x-auto overflow-y-auto rounded-xl border border-base-300 bg-base-100 shadow-sm">
      <table className="table table-zebra">
        <thead>
          <tr className="bg-base-200">
            <th className="font-semibold text-base-content">Device / Drug Name</th>
            <th className="font-semibold text-base-content">Type</th>
            <th className="font-semibold text-base-content">Total Journals</th>
            <th className="font-semibold text-base-content">Search terms (Claims relevant)</th>
            <th className="font-semibold text-base-content text-right">Action</th>
          </tr>
        </thead>
        <tbody>
          {devices.map((device, idx) => {
            const deviceName = device?.name ?? device;
            const disableButton = loading || Boolean(ingestingDevice);
            return (
              <tr key={device.id ?? device.name ?? idx} className="hover:bg-base-200/50">
                <td className="font-medium">{device.name}</td>
                <td>{device.type ?? "Device"}</td>
                <td>{device.total_journals ?? "—"}</td>
                <td className="max-w-xs">
                  {device.search_terms?.length ? (
                    <ul className="list-inside list-disc text-sm">
                      {device.search_terms.map((st, i) => (
                        <li key={i}>
                          <span className="font-medium">{st.term}</span>
                          <span className="text-base-content/70">
                            {" "}
                            → {st.claims_relevant_articles} claims relevant
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    "—"
                  )}
                </td>
                <td className="text-right">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={() => onDeepAnalyse(device)}
                    disabled={disableButton}
                  >
                    Deep Analyse
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DeviceTable;
